(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-list-slider"] && !window.DesignMode) return;
  try {
    

$(document).ready(function(){
  $(".owl-carousel_collections").owlCarousel({
    loop:true,
             margin:15,
             navText:'',
             responsiveClass:true,
             dots:false,
             nav:true,
             responsive:{
                 0:{
                     items:2
                 },
                 540:{
                     items:3
                 },
                 750:{
                   items: 4
                 },
                 1024:{
                     items:5
                 }
             }
  });
});

$(document).ready(function(){
  $(".owl-carousel_collections--no-loop").owlCarousel({
    loop:false,
             margin:15,
             navText:'',
             responsiveClass:true,
             dots:false,
             nav:true,
             responsive:{
              0:{
                items:2
                },
                540:{
                    items:3
                },
                750:{
                  items: 4
                },
                1024:{
                    items:5
                }
             }
  });
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-collections"] && !window.DesignMode) return;
  try {
    

let tabs = document.querySelectorAll('#tabs li');
let collections = document.querySelectorAll('.the-collections > div');

for (let i = 0; i < tabs.length; i++) {
  tabs[i].onclick = function() {
    let c = 0;
    while (c < tabs.length) {
      tabs[c++].className = '';
      collections.forEach(collection => collection.classList.add('hidden'));
    }
    tabs[i].className = 'current';   
    collections[i].classList.remove('hidden');
  }
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('ul'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    onItemClick(event) {
      event.preventDefault();
      this.elements.input.value = event.currentTarget.dataset.value;
      this.querySelector('form')?.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.elements.button.setAttribute('aria-expanded', 'false');
        this.elements.panel.setAttribute('hidden', true);
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gif"] && !window.DesignMode) return;
  try {
    

function isOnScreen(element) {
  if( element.length == 0 ) {
    return;
  }
  let $window = jQuery(window)
  let viewport_top = $window.scrollTop()
  let viewport_height = $window.height()
  let viewport_bottom = viewport_top + viewport_height
  let $element = jQuery(element)
  let top = $element.offset().top
  let height = $element.height()
  let bottom = top + height

  return (top >= viewport_top && top < viewport_bottom) ||
  (bottom > viewport_top && bottom <= viewport_bottom) ||
  (height > viewport_height && top <= viewport_top && bottom >= viewport_bottom)
}

let playing = false;
//let busy = false;

let atScroll = window.addEventListener('scroll', startPlayingQuotes);

function startPlayingQuotes(e) {
  if( isOnScreen( $( '.gif' ) )) {
    playing = true;
    playQuotes();
    window.removeEventListener('scroll', startPlayingQuotes);
  }
}

function playQuotes() {
  //busy = true;
  const quote_1 = $(".quote_1");
  quote_1.fadeIn(500).delay(1200).fadeOut(500, function() {
    const quote_2 = $(".quote_2");
    quote_2.fadeIn(500).delay(1200).fadeOut(500, function() {
      const quote_3 = $(".quote_3");
      quote_3.fadeIn(500).delay(1200).fadeOut(500, function() {
        playQuotes();
        //busy = false;
      });
    });
  });
  //console.log("exiting method");
}
 


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    

  /* DAWN */

  

  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;

      this.onScrollHandler = this.onScroll.bind(this);

      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        requestAnimationFrame(this.reveal.bind(this));
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-banner-slider"] && !window.DesignMode) return;
  try {
    


$(document).ready(function(){
  $(".owl-carousel_banner").owlCarousel({
    loop:false,
             margin:15,
             navText:'',
             responsiveClass:true,
             dots:false,
             nav:true,
             autoplay:false,
             slideSpeed: 300,
             responsive:{
                 0:{
                     items:1
                 },
                 640:{
                     items:1
                 },
                 1024:{
                     items:1
                 }
             }
  });
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 300))
    }
  }

  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
      window.pauseAllMedia();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
          element.classList.remove('active');
        }
      )
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMedia.querySelector('template')?.content?.querySelector('.js-youtube'))
        activeMedia.loadContent();
    }
  }

  customElements.define('product-modal', ProductModal);

  /*
  class ProductGallery extends HTMLElement {
    constructor() {
      super();
      this.init()
  
      // Add resize observer to update container height
      const resizeObserver = new ResizeObserver(entries => this.update());
      resizeObserver.observe(this);
  
      // Bind event listeners
      this.navItems.forEach(item => item.addEventListener('click', this.onNavItemClick.bind(this)))
      this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
      this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
      // Listen for variant selection change to make current variant image active
      window.addEventListener('message', this.onVariantChange.bind(this))
    }
  
    init() {
      // Set up our DOM element variables
      this.imagesContainer = this.querySelector('.product-gallery__images');
      this.navItems = this.querySelectorAll('.product-gallery__nav-item');
      this.images = this.querySelectorAll('.product-gallery__image');
      this.prevButton = this.querySelector('button[name="previous"]');
      this.nextButton = this.querySelector('button[name="next"]');
      // If there is no active images set the first image to active
      if (this.findCurrentIndex() === -1) {
        this.setCurrentImage(this.images[0])
      }
    }
  
    onVariantChange(event) {
      if (!event.data || event.data.type !== 'variant_changed') return 
      const currentImage = Array.from(this.images).find(item => item.dataset.mediaId == event.data.variant.featured_media.id)
      if (currentImage) {
        this.setCurrentImage(currentImage)
      }
    }
  
    onNavItemClick(event) {
      const mediaId = event.target.closest('li').dataset.mediaId
      this.images.forEach(item => item.classList.remove('product-gallery__image--active'))
      this.setCurrentImage(Array.from(this.images).find(item => item.dataset.mediaId === mediaId))
    }
  
    update() {
      this.style.height = `${this.imagesContainer.offsetHeight}px`
      this.prevButton.removeAttribute('disabled')
      this.nextButton.removeAttribute('disabled')
      if (this.findCurrentIndex() === 0) this.prevButton.setAttribute('disabled', true)
      if (this.findCurrentIndex() === this.images.length - 1) this.nextButton.setAttribute('disabled', true)
    }
  
    setCurrentImage(elem) {
      this.images.forEach(item => item.classList.remove('product-gallery__image--active'))
      elem.classList.add('product-gallery__image--active')
      this.update()
    }
  
    findCurrentIndex() {
      return Array.from(this.images).findIndex(item => item.classList.contains('product-gallery__image--active'))
    }
  
    onButtonClick(event) {
      event.preventDefault();
      let index = this.findCurrentIndex()
      if (event.currentTarget.name === 'next') {
        index++
      } else {
        index--
      }
      this.setCurrentImage(this.images[index])
    }
  }
  
  customElements.define('product-gallery', ProductGallery);*/


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');
            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();
})();
